import { render, staticRenderFns } from "./OrderMergeDrawer.vue?vue&type=template&id=195860f4&scoped=true"
import script from "./OrderMergeDrawer.vue?vue&type=script&lang=js"
export * from "./OrderMergeDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderMergeDrawer.vue?vue&type=style&index=0&id=195860f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195860f4",
  null
  
)

export default component.exports